import {
  ChakraBox,
  ChakraFlex,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
} from '@equip.health/ui';
import { DateTime } from 'luxon';

import {
  NOTIFICATION_HEADER_STYLES,
  NotificationEventType,
  NotificationStatus,
} from '~/lib/constants/notifications.constants';
import { getNotificationText } from '~/lib/util/notification.util';

import NotificationAvatar from '../NotificationAvatar';
import NotificationDetailWrapper from '../NotificationDetailWrapper';
import NotificationTimeStamp from '../NotificationTimeStamp';

const TOP_LEVEL_ID = 'notification-inquiry-referral';

interface NotificationInquiryReferralProps {
  createdAt?: string;
  eventType?: NotificationEventType;
  isRead?: boolean;
  newStatus?: string;
  notificationExternalId?: string;
  oldStatus?: string;
  onUpdateNotification?: (
    notificationExternalIds: Array<string>,
    status: NotificationStatus,
  ) => void;
  patientName?: string;
  type?: string;
}

const { paragraph, paragraphBold, label, labelBold } = EquipUITheme.typography;
const { primary } = EquipUIFireflyV2Theme.colors;

const NotificationInquiryReferral = ({
  createdAt,
  eventType,
  isRead,
  newStatus,
  notificationExternalId,
  oldStatus,
  onUpdateNotification,
  patientName,
  type,
}: NotificationInquiryReferralProps) => {
  return (
    <>
      <ChakraFlex alignItems="start" justifyContent="space-between">
        <NotificationAvatar patientName={patientName} />
        <ChakraBox
          {...paragraph}
          id={`${TOP_LEVEL_ID}-header`}
          {...NOTIFICATION_HEADER_STYLES}
        >
          <span style={{ ...paragraphBold, lineHeight: '16.8px' }}>
            {patientName}
          </span>
          &nbsp;
          <span>{getNotificationText(eventType, type)}</span>
        </ChakraBox>
        <NotificationTimeStamp
          createdAt={createdAt}
          isRead={isRead}
          notificationExternalId={notificationExternalId}
          onUpdateNotification={onUpdateNotification}
        />
      </ChakraFlex>
      <ChakraFlex {...label} margin="8px 40px 0px">
        <NotificationDetailWrapper>
          <ChakraText {...labelBold} id={`${TOP_LEVEL_ID}__old-status`}>
            {type === 'date'
              ? DateTime.fromISO(oldStatus).toFormat('LL/dd/yyyy')
              : oldStatus}
          </ChakraText>
          <ChakraText color={primary[100]} paddingX="8px">
            -&gt;
          </ChakraText>
          <ChakraText {...labelBold} id={`${TOP_LEVEL_ID}__new-status`}>
            {type === 'date'
              ? DateTime.fromISO(newStatus).toFormat('LL/dd/yyyy')
              : newStatus}
          </ChakraText>
        </NotificationDetailWrapper>
      </ChakraFlex>
    </>
  );
};

export default NotificationInquiryReferral;
